import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './Modal.module.scss';
import Text from '../Text';
import { Size } from '../../../../Enums/Size.enum';
import { useAppContext } from '../../../../Services/AppContext';
import { joinClasses } from '../../../../Utils/className.util';

interface ModalProps {
	opened: boolean;
	fullScreen?: boolean;
	onClose?: () => void;
	size?: Size;
	maxHeight?: boolean;
	contentScroll?: boolean;
	wrapChat?: boolean;
	contentStyle?: object;
}

const Header = ({
	title,
	onClose,
}: {
	title: string;
	onClose?: () => void;
}) => {
	const { translation } = useAppContext();
	const handleClose = () => {
		onClose?.();
	};

	useEffect(() => {
		const close = (e: any) => {
			if (e.keyCode === 27) {
				handleClose();
			}
		};
		window.addEventListener('keydown', close);
		return () => window.removeEventListener('keydown', close);
	}, []);

	return (
		<div className={styles.header}>
			<div className={styles.headerTitle}>
				<Text tx={title} firstUpper={true} inline={true} />
			</div>
			{onClose && (
				<div className={styles.close} onClick={handleClose}>
					{translation['base.shared.close']}
				</div>
			)}
		</div>
	);
};

const Content = (props: any) => {
	return (
		<div
			style={props.contentStyle}
			className={joinClasses([
				styles.content,
				props.fullScreen && styles.fullScreenScroll,
				props.maxHeight && styles.maxHeight,
				props.contentScroll && styles.contentScroll,
			])}
		>
			{props.children}
		</div>
	);
};

const Footer = () => {
	return <div>footer</div>;
};

class Modal extends React.Component {
	private el: HTMLDivElement;
	private modalRoot: HTMLElement;
	static Header: (props: any) => JSX.Element;
	static Content: (props: any) => JSX.Element;
	static Footer: (props: any) => JSX.Element;
	public props: any;

	constructor(props: ModalProps) {
		super(props);
		this.modalRoot = document.getElementById('modal-root');
		this.el = document.createElement('div');
	}

	componentDidMount() {
		const modalRoot = this.modalRoot;
		if (modalRoot) {
			modalRoot.appendChild(this.el);
		}
	}

	componentWillUnmount() {
		const modalRoot = this.modalRoot;
		if (modalRoot) {
			modalRoot.removeChild(this.el);
		}
	}

	handleClose(props: any) {
		props.onClose?.();
	}

	render() {
		return ReactDOM.createPortal(
			<>
				{this.props.opened && (
					<div
						className={joinClasses([
							styles.wrapper,
							this.props.wrapChat && styles.showChat,
						])}
					>
						<div
							className={styles.backdrop}
							onClick={() => this.handleClose(this.props)}
						/>
						<div
							className={joinClasses([
								styles.modal,
								this.props.fullScreen && styles.fullScreen,
								this.props.size && styles[this.props.size],
							])}
						>
							{React.Children.map(this.props.children, child =>
								React.cloneElement(child, {
									onClose: () => this.handleClose(this.props),
								}),
							)}
						</div>
					</div>
				)}
			</>,
			this.el,
		);
	}
}

Modal.Header = Header;
Modal.Content = Content;
Modal.Footer = Footer;

export default Modal;
